<ng-container>
  <table class="table marginTopTwentyPx" aria-label="Participant List">
    <thead>
      <tr>
        <th scope="col" (click)="sortParticipants('name')" (keyup)="sortParticipants('name')" class="sortable-heading">
          Name
          @if (sortColumn === 'name') {
            <img [src]="getSortIcon('name')" alt="Sort Icon">
          }
        </th>
        <th scope="col" (click)="sortParticipants('role')" (keyup)="sortParticipants('role')" class="sortable-heading">
          Role
          @if (sortColumn === 'role') {
            <img [src]="getSortIcon('role')" alt="Sort Icon">
          }
        </th>
        <th scope="col" (click)="sortParticipants('email')" (keyup)="sortParticipants('email')" class="sortable-heading">
          Email Address
          @if (sortColumn === 'email') {
            <img [src]="getSortIcon('email')" alt="Sort Icon">
          }
        </th>
        <th scope="col">{{ isVirtualMeeting() ? 'Host Link' : 'Participant Link' }}</th>
        @if (isVirtualMeeting()) {
          <th scope="col">Guest Link</th>
        } @else {
          <th scope="col" (click)="sortParticipants('status')" (keyup)="sortParticipants('status')" class="sortable-heading">
            Pre-Sign Status
            @if (sortColumn === 'status') {
              <img [src]="getSortIcon('status')" alt="Sort Icon">
            }
          </th>
        }
        @if (showActions) {
          <th scope="col">Actions</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (participant of participants; track participant) {
        <tr data-cy="participantRecord">
          @if (participant.participantModifiable; as participantName) {
            <td [attr.data-cy]="'participant-' + participant.id"
              class="participant-column"
              >
              <div ngbTooltip="{{ participantName | participantDisplayNameTooltip }}">
                {{ participantName | participantDisplayName }}
              </div>
            </td>
          }
          <td>{{ getFriendlyRole(participant) }}</td>
          <td>{{ participant.participantModifiable.email }}</td>
          <td>
            @if (isVirtualMeeting()) {
              @if (isAttorney(participant) && hostMeetingUrl) {
                <button type="button" class="meeting-link-copy" (click)="copyToClipboard(hostMeetingUrl)" title="Copy host link" aria-label="Copy host link">
                  <span>Copy Link</span>
                  <span class="fas fa-copy ms-1" aria-hidden="true"></span>
                </button>
              }
            } @else {
              <div [showIfHasCapability]="[
                  {
                    capabilityString: 'CanGetAllSessionLinks',
                    type: 'order',
                    id: orderId
                  },
                  {
                    capabilityString: 'CanGetMySessionLink',
                    type: 'participant',
                    id: participant.id
                  }
                ]">
                @if (participantHasLink(participant) && canGetLink$ | async) {
                  <a
                    class="nav-link"
                    (click)="handleGeturlAction(participant)">
                    Get Link
                  </a>
                }
              </div>
            }
          </td>
          @if (isVirtualMeeting()) {
            <td>
              @if (isAttorney(participant) && guestMeetingUrl) {
                <button type="button" class="meeting-link-copy" (click)="copyToClipboard(guestMeetingUrl)" title="Copy guest link" aria-label="Copy guest link">
                  <span>Copy Link</span>
                  <span class="fas fa-copy ms-1" aria-hidden="true"></span>
                </button>
              }
            </td>
          } @else {
            <td>
              {{ translateParticipantIdToPreSignStatus(participant.id) }}
            </td>
          }
        @if (showActions) {
          <td>
            <div>
              @if (!isOrderLocked) {
                <img
              [showIfHasCapability]="[{
                capabilityString: 'CanEditParticipant',
                type: 'participant',
                id: participant?.id
              }]"
                  (click)="handleEditAction(participant)"
                  (keyup)="handleEditAction(participant)"
                  title="Edit Participant"
                  class="action-item"
                  src="assets/icons/edit.svg" alt="Edit Participant"
                  >
              }
              <img
              [showIfHasCapability]="[{
                capabilityString: 'CanResetLogin',
                type: 'participant',
                id: participant?.id
              }]"
                (click)="handleResetLoginAction(participant)"
                (keyup)="handleResetLoginAction(participant)"
                title="Reset Login"
                class="action-item"
                src="assets/icons/reset.svg" alt="Reset Login"
                >
                @if (!isOrderLocked) {
                  <img
              [showIfHasCapability]="[{
                capabilityString: 'CanRemoveParticipant',
                type: 'participant',
                id: participant?.id
              }]"
                    (click)="handleRemoveAction(participant)"
                    (keyup)="handleRemoveAction(participant)"
                    title="Delete Participant"
                    class="action-item"
                    src="assets/icons/trash.svg" alt="Delete Participant"
                    >
                }
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</ng-container>
